import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { clubAPI, userSettingsAPI } from '../../services/api';
import './SettingsPage.css';

function LeaveClub() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [clubs, setClubs] = useState([]);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadClubs();
  }, []);

  const loadClubs = async () => {
    try {
      setLoading(true);
      const data = await clubAPI.listClubs();
      setClubs(data.clubs || []);
    } catch (error) {
      setMessage({
        type: 'error',
        text: 'Failed to load clubs',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleLeaveClub = async (clubId, clubName) => {
    if (!window.confirm(`Are you sure you want to leave "${clubName}"? This action cannot be undone.`)) {
      return;
    }

    try {
      await userSettingsAPI.leaveClub(clubId);
      setMessage({
        type: 'success',
        text: `You have left "${clubName}" successfully`,
      });
      loadClubs();
    } catch (error) {
      setMessage({
        type: 'error',
        text: error.response?.data?.message || 'Failed to leave club',
      });
    }
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="settings-page-content">
      <h2>Leave a Club</h2>
      <p className="page-description">
        Manage your club memberships. Leaving a club will remove you from all club activities.
      </p>

      {message.text && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      {clubs.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">⭐</div>
          <h3>No Clubs Found</h3>
          <p>You're not currently a member of any clubs.</p>
          <button onClick={() => navigate('/register/club')} className="btn btn-primary">
            Start a Club
          </button>
        </div>
      ) : (
        <div className="item-list">
          {clubs.map((club) => (
            <div key={club.clubId} className="item-card">
              <div className="item-info">
                <h4>{club.clubName}</h4>
                <p>
                  Members: {club.memberCount || 0} • Created: {new Date(club.created).toLocaleDateString()}
                </p>
              </div>
              <div className="item-actions">
                <button
                  onClick={() => handleLeaveClub(club.clubId, club.clubName)}
                  className="btn btn-danger"
                >
                  Leave Club
                </button>
              </div>
            </div>
          ))}
        </div>
      )}

      <div className="info-box" style={{ marginTop: '30px' }}>
        <p>
          <strong>Warning:</strong> Leaving a club is permanent. You will need to be re-invited
          to join again. Any pending bets or contributions may be forfeited.
        </p>
      </div>
    </div>
  );
}

export default LeaveClub;
